export default __webpack_public_path__ + "static/Greycliffcf-demibold-webfont-f5af592ffca863ccfda9d1c46b4f35ae.woff2";